import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators, AbstractControl } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
// import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ChangeDetectorRef } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import { log } from 'console';

@Component({
  selector: 'app-practical-time-table',
  templateUrl: './practical-time-table.component.html',
  styleUrls: ['./practical-time-table.component.scss']
})
export class PracticalTimeTableComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  ExamTimeTable: FormGroup;
  ExamTTSearchForm;
  ExamList: any;
  examList: any;
  ExamFilterList: any;
  dialogRef: MatDialogRef<any>;
  ExmTimeTable: [];
  ExamArray: FormArray;
  submitpayload: any;
  Time: string;
  Totime: string;
  maxTime: string;
  maxDate: Date;
  date: any;
  holidayDate: any;
  // holidayDates: Date[] = [];
  holidayDates: { FromDate: Date, ToDate: Date, HolidayName: string }[] = [];
  time: any;
  date2: any;
  time2: any;
  SId: any;
  arr
  SessionNo: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  errMsg: any;
  selectedHoliday: any;
  BtnDisable = false;
  examRecords: any;
  examarr: any;
  centId: any;
  ShId: any;
  BranchList: any;
  filteredListBranch: any;
  Branch: boolean;
  AissgneCount: any;
  UserCollege: string;
  showBranch: boolean = false;
  selectedExam: any;
  InstuName: string = 'Srimanta Sankaradeva University of Health Sciences';
  selectedSession: any;
  selectedCollege: any;
  selectedCourse: any;
  
  constructor(public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private router: Router, private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private cdr: ChangeDetectorRef
  ) { }

  istableShow = false;
  currentdate: any;

  userPermission: any;
  utp: string;
  exTimeUpdate = true;
  exTimeCreate = true;

  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  filteredListExam: any[] = [];
  collegeList: any[] = [];
  filteredCollegeList: any[] = [];
  tableData: any[] = [];
  subjectList: any[] = [];
  filteredsubjectList: any[] = [];
  EsCode: any;
  updateBtn: Boolean = false
  action: Boolean = false
  selectedSubjects: any[] = [];
  StudentPersonalId: any;
  cutoffDetails: any;
  ngOnInit(): void {
    // if (JSON.parse(sessionStorage.getItem("session")) == null) {
    //   // this.fetchSecretData();
    //   this.umsService.getSecretData().subscribe((res) => {
    //     this.SessionNo = res.projectPharam['SnNo'];
    //     this.fetchExamSchedule(this.SessionNo);
    //   }
    //   );
    // }
    // else if (JSON.parse(sessionStorage.getItem("session")) != null) {
    //   let sessionData = JSON.parse(sessionStorage.getItem("session"));
    //   this.SessionNo = sessionData.SnNo;
    //   this.fetchExamSchedule(this.SessionNo);
    // }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    this.fetchSession();
    // this.getClgMapp();
    this.getHoliday();

    // if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
    //   // this.isSuperAdmin= false;
    //   this.userPermission.forEach(element => {
    //     if (element.PageName == 'Exam-Timetable' && element.PCreate == false) {
    //       this.exTimeCreate = false;
    //     }
    //     if (element.PageName == 'New-Exam-Code' && element.PUpdate == false) {
    //       this.exTimeUpdate = false;
    //     }
    //   });
    // }

    window.scroll(0, 0);
    this.istableShow = false;
    this.currentdate = new Date();
    this.maxDate = new Date(3000, 12, 31);
    this.ExamTimeTable = this.fb.group({
      SessionId: new FormControl('', [Validators.required]),
      CoCode: new FormControl('', [Validators.required]),
      EmId: new FormControl('', [Validators.required]),
      CgCode: new FormControl('', [Validators.required]),
      strId: new FormControl(''),
      // PStudCnt: new FormControl(''),
      // BatchSize: new FormControl(''),
      // AssigCnt: new FormControl(''),
      ExamArray: new FormArray([]),
    });
    this.fetchSession();
    // this.getClgMapp();
    this.getHoliday();

    // Auto-load practical timetable for logged-in student
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.getCutoffDateForStudent();
    this.loadAdmissionAndTimetable();
  }


  getExamArrayControls() {
    return (this.ExamTimeTable.get('ExamArray') as FormArray).controls;
  }

  // Custom Validator to check for past dates
  dateNotInPastValidator(control: AbstractControl) {
    const selectedDate = new Date(control.value);
    if (selectedDate < new Date()) {
      return { 'pastDate': true };
    }
    return null;
  }

onExamSelect(item: any) {
  this.selectedExam = item;

  if (item.EmStreams === 'Y') {
    this.showBranch = true;

    // 🔥 CALL API HERE
    this.fetchBranch(item.EmId);

  } else {
    this.showBranch = false;
    this.ExamTimeTable.patchValue({ strId: null });

    // optional auto-load
    // this.getTimetableData();
  }
}



  getTimetableData() {
    // this.spinner.show();
    this.istableShow =true
    const payload = {};
    payload['PtCoCode'] = this.ExamTimeTable.value.CoCode;
    payload['PtCgCode'] = this.ExamTimeTable.value.CgCode;
    payload['PtEmId'] = this.ExamTimeTable.value.EmId;
    payload['PtCent'] = this.ExamTimeTable.value.CgCode;
    payload['PtSnNo'] = this.ExamTimeTable.value.SessionId;
    payload['PtStrId'] = this.ExamTimeTable.value.strId

    this.umsService.getPracticalTimeTable(payload).subscribe(res => {
      if (res.status == true) {
        
        this.ShId = res.data[0].ShId
        this.action = true
        this.exTimeCreate = false
        const data = res.data;
        
        const creds = this.ExamTimeTable.controls.ExamArray as FormArray;
        creds.clear();
        data.forEach((element, i) => {
            let timeFrom = element.PtTimeFrom ? element.PtTimeFrom.split('T') : [];
  let timeTo = element.PtTimeTo ? element.PtTimeTo.split('T') : [];

  this.date = timeFrom.length > 0 ? timeFrom : ['1900-01-01', '00:00:00.000Z'];
  this.time = this.date[1] ? this.date[1].split(':00.000Z') : ['00:00'];

  this.date2 = timeTo.length > 0 ? timeTo : ['1900-01-01', '00:00:00.000Z'];
  this.time2 = this.date2[1] ? this.date2[1].split(':00.000Z') : ['00:00'];
      //  this.date = element.PtTimeFrom.split('T');
      // this.time = this.date[1].split(':00.000Z');
      // this.date2 = element.PtTimeTo.split('T');
      // this.time2 = this.date2[1].split(':00.000Z');
          if (element.PtDate == "1900-01-01" && element.PtTimeFrom == "00:00:00:00" && element.PtTimeTo == "00:00:00:00") {
            this.spinner.hide();
            creds.push(
              this.fb.group({
                Date: new FormControl('', [Validators.required]),
                PtTimeFrom: new FormControl('', [Validators.required]),
                PtTimeTo: new FormControl('', [Validators.required]),
                EsCode: new FormControl(element.EsCode),
                EsId: new FormControl(element.PtEsId),
                SubName: new FormControl(element.SubName),
                HeadName: new FormControl(element.EsName),
                // EsName: new FormControl(element.EsName),
                PtEsPSubId :new FormControl(element.EsPSubId),
              })
            );

            this.exTimeCreate = true
            this.updateBtn = false
          }
          else {
      // this.spinner.hide()
            creds.push(
              this.fb.group({
                PtId: new FormControl(element.PtId),
                Date: new FormControl({value: element.PtDate, disabled: true},[Validators.required]),
                PtTimeFrom: new FormControl({ value: element.PtTimeFrom, disabled: true }),
                PtTimeTo: new FormControl({ value: element.PtTimeTo, disabled: true }),
                EsId: new FormControl(element.PtEsId),
                EsCode: new FormControl(element.EsCode),
                SubName: new FormControl(element.SubName),
                HeadName: new FormControl(element.EsName),
                // EsName: new FormControl(element.EsName),
                PtEsPSubId :new FormControl(element.EsPSubId),
              })
            );
            this.updateBtn = true
            this.exTimeCreate = false
          }
        });


      }
      else {
        this.istableShow = false
        // this.spinner.hide()
        let data = {}
        data['message'] = 'No Data Found'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })



  }




  getTable() {

    const examArrayControl = this.ExamTimeTable.get('ExamArray');
    examArrayControl?.clearValidators();
    examArrayControl?.updateValueAndValidity({ onlySelf: true });
    if (this.ExamTimeTable.invalid) {
      this.ExamTimeTable.get('CoCode').markAsTouched();
      this.ExamTimeTable.get('CgCode').markAsTouched();
      this.ExamTimeTable.get('EmId').markAsTouched();
      this.ExamTimeTable.get('SessionId').markAsTouched();
      examArrayControl?.clearValidators();
    } else {
      this.istableShow = true;
      this.getTimetableData();
    }
    // if (this.ExamTimeTable.valid) {
    //   console.log('this.ExamTimeTable',this.ExamTimeTable);

    //   this.spinner.show();
    //   const formData = this.ExamTimeTable.value;
    //   this.tableData = Array.isArray(formData) ? formData : [formData];
    //   this.istableShow = true;
    //   this.getTimetableData();
    // } else {
    //   // this.markFormGroupTouched(this.ExamTimeTable.);
    //   console.log('this.iiiiiiiiiii',this.ExamTimeTable)
    //     this.ExamTimeTable.get('CoCode').markAsTouched();
    //     this.ExamTimeTable.get('CgCode').markAsTouched();
    //     this.ExamTimeTable.get('EmId').markAsTouched();
    //     this.ExamTimeTable.get('SessionId').markAsTouched();
    // }
  }

  markFormGroupTouched(formGroup: FormGroup | FormArray) {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getTable2(item) {
    this.ExamList = [];
    this.istableShow = true;
    const payload = {};
    payload['ShId'] = item;
    // this.SId = item.ShId;
    if (item.ShStatus == 'U') {
      this.BtnDisable = true;
    } else {
      this.BtnDisable = false;
    }

    this.getCenterAllocation(item)
    this.umsService.getExamTT(payload).subscribe(res => {
      this.ExamList = res.data;
      this.getTimetableData()


    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
  }


  fetchSession() {
    this.istableShow = false;


    this.spinner.show();
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }


  getCourse(data) {
    this.selectedCollege = data;
    this.submitpayload = this.ExamTimeTable.value;
    this.istableShow = false;
    // this.ExamTimeTable.reset({
    //   SessionId: this.SessionNo,
    //   CoCode: '',
    //   EmId: '',
    //   CgCode: '',
    //   ExamArray: []
    // });

    this.spinner.show();
    const payload = {};
        this.ExamTimeTable.controls['EmId'].setValue('');
    payload['CgCode'] = this.submitpayload.CgCode;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getExamList(e) {
    this.istableShow = false;
    this.selectedCourse = e;
    this.spinner.show();
    // this.ExamTimeTable.reset({
    //   SessionId: this.SessionNo,
    //   CoCode: e.CoCode,
    //   EmId: '',
    //   CgCode: '',
    //   ExamArray: []
    // });
    const payload = {};
    payload['EmCoCode'] = e.CoCode;
    this.examList = []
    this.umsService.getExamForStudent(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }
  get(data) {
    this.spinner.show();
    if (data.EmStreams == "Y") {
      this.Branch = true;
      this.fetchBranch(data.EmId);
    }
    else {
      this.spinner.hide();
      this.Branch = false;
      // this.disableNew = false;
      // this.filterlist = [];
      // // this.selecttype = false;
      const payload = {};
      payload['EsEmId'] = data.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();
        if (res) {
          res.data.children
            .forEach(element => {
              if (element.EsType == 'S') {
                this.subjectList.push(element)
              }
              else if (element.EsType == 'G') {
                element.children.forEach(grpSub => {
                  this.subjectList.push(grpSub)
                });
              }
              this.filteredsubjectList = this.subjectList.slice();
              // this.sub = this.filteredsubjectList[0].EsCode
            });
        }
        else {
          this.spinner.hide();
          let data = {}
          data['message'] = 'Subject Not Found'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      });
    }
  }

  fetchBranch(id) {
    const payload = {};
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getStr(e) {
    const payload = {};
    this.subjectList = []
    this.filteredsubjectList = []
    payload['EsEmId'] = this.ExamTimeTable.value.EmId;
    payload['EsStrId'] = this.ExamTimeTable.value.strId
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {

      this.spinner.hide();
      if (res) {
        res.data.children
          .forEach(element => {
            if (element.EsType == 'S') {
              this.subjectList.push(element)
            }
            else if (element.EsType == 'G') {
              element.children.forEach(grpSub => {
                this.subjectList.push(grpSub)
              });
            }
            this.filteredsubjectList = this.subjectList.slice();
            // this.sub = this.filteredsubjectList[0].EsCode
          });
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = 'Subject Not Found'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }

    });
  }
  getClgMapp(data) {
    this.selectedSession = data;
    // this.get(data)
    this.istableShow = false;
    this.spinner.show();
    
    // this.ExamTimeTable.reset({
    //   SessionId: data.SnNo,
    //   CoCode: '',
    //   EmId: '',
    //   CgCode: '',
    //   ExamArray: []
    // });
        
        this.ExamTimeTable.controls['CoCode'].setValue('');
        this.ExamTimeTable.controls['EmId'].setValue('');
        
   if (this.userPermission && this.userPermission.length > 0 && this.userPermission[0].CgUi === 'C') {
    this.UserCollege = this.userPermission[0].CgId;
  } else {
    this.UserCollege = '';
  }

  console.log('STEP 4: UserCollege =', this.UserCollege);
  //   if (this.userPermission[0].CgUi == 'C') {
  //     this.UserCollege = this.userPermission[0].CgId;
  //   }
  //   else {
  //     this.UserCollege = ''
  //   }
    const payload3 = {};
    this.submitpayload = this.ExamTimeTable.value;
    payload3['CgCode'] = this.UserCollege ?? this.submitpayload.CgCode;
     console.log('STEP 5: payload3 =', payload3);
    this.umsService.getCollege(payload3).subscribe(res => {
        console.log('STEP 6: API response', res);
      if (res.status) {
        this.spinner.hide();
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  college(item: any) {
    this.centId = item
    this.istableShow = false;
  }

  // submit() {
  //   this.spinner.show();
  //   this.submitpayload = this.ExamTimeTable.value;
  //   let arr = [];
  //   arr = this.submitpayload.ExamArray
  //   let iserror = false;
  //   // payload['SnNo'] = this.SessionNo;

  //   var bar = new Promise<void>((resolve, reject) => {
  //     const payloadArray = [];  // Collect all payloads in an array

  //     arr.forEach((element, index) => {
  //       console.log('element', element)
  //       let fromDate = element.Date;
  //       let toDate = element.ToDate;
  //       element.Date = this.datepipe.transform(fromDate, 'yyyy-MM-dd');
  //       this.Time = element.Date + 'T' + element.PtTimeFrom + ':00.000Z'
  //       this.Totime = element.Date + 'T' + element.PtTimeTo + ':00.000Z'
  //       element.PtTimeFrom = this.Time;
  //       element.PtTimeTo = this.Totime;
  //       // if (element.AssigCnt == 0 || element.AssigCnt === 0) {
  //       //   this.AissgneCount = 1
  //       // } else {
  //       //   this.AissgneCount = element.AssigCnt
  //       // }

  //       const payload = {
  //         PtSnNo: this.submitpayload.SessionId ? this.submitpayload.SessionId : this.SessionNo,
  //         PtCoCode: this.submitpayload.CoCode,
  //         PtCgCode: this.submitpayload.CgCode,
  //         PtEmId: this.submitpayload.EmId,
  //         PtCent: this.submitpayload.CgCode,
  //         PtSubCode: element.EsCode,
  //         PtEsId: element.EsId,
  //         PtDate: element.Date,
  //         PtTimeFrom: this.Time,
  //         PtTimeTo: this.Totime,
  //         PtEsPSubId: element.PtEsPSubId,
  //       };

  //       payloadArray.push(payload);  // Add each payload to the array
  //     });
  //     this.umsService.savePracticalTimeTable(payloadArray).subscribe(res => {
  //       this.spinner.hide();
  //       if (res.status == false) {
  //         this.spinner.hide();
  //         let data = {}
  //         data['message'] = this.errMsg
  //         data['title'] = 'Alert'
  //         data['icon'] = 'fas fa-close'
  //         // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       }
  //       // if (index === array.length - 1) resolve();
  //       else {
  //         this.spinner.hide();
  //         this.exTimeCreate = false;
  //         this.updateBtn = true
  //         let data = {}
  //         data['message'] = "Submitted Successfully"
  //         data['title'] = 'Information'
  //         data['icon'] = 'fas fa-check'
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //         this.getTimetableData()
  //       }
  //     }, (ERROR: HttpErrorResponse) => {
  //       this.spinner.hide();
  //       iserror = true;
  //       this.errMsg = ERROR.error.message
  //       // if (index === array.length - 1) resolve();
  //     });
  //   })

  // }

  // print() {
  //   let submitpayload = this.ExamTimeTable.value;
  //   let payload1 = {}
  //   payload1['MenuName'] = 'PracticalTimeTable';
  //   payload1['ExamId'] = submitpayload.EmId;
  //   payload1['CentId'] = submitpayload.CgCode;
  //   payload1['SessionId'] = submitpayload.SessionId
  //   // payload1['ShId'] = submitpayload.Exam

  //   let jsonString = JSON.stringify(payload1)
  //   var filter: any;
  //   filter = {
  //     "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
  //     "RptCode": 313,
  //     "InstName": '',
  //     // "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
  //     "InstNo": 0,
  //     "ShId": this.ShId,
  //     "CgCode": submitpayload.CgCode,
  //     "RollNo": '',
  //     "Cent": submitpayload.CgCode,
  //     "TnCode": '',
  //     "EsId": '',
  //     "CsNo": '',
  //     "PgBreak": '',
  //     "StrId": '',
  //     "StrCode": '',
  //     "RgNo": '',
  //     "UC": '',
  //     "Ledger": '',
  //     "RegnRoll": '',
  //     "DsCode": '',
  //     "CoCode": submitpayload.CoCode,
  //     "SnNo": submitpayload.SessionId,
  //     "Extra1": jsonString,
  //       "InstituteCode" : ''
  //   }

  //   var payload: any;
  //   payload = filter;
  //   this.umsService.setData(JSON.stringify(payload));
  //   this.redirect('reports')
  // }
  redirect(to): void {
    this.router.navigate([to]);
  }

  // save() {
  //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
  //   if (this.ExamTimeTable.invalid) {
  //     this.arr.controls.forEach(element => {
  //       element.get('Date')?.markAsTouched();
  //       element.get('PtTimeFrom').markAsTouched();
  //       element.get('PtTimeTo').markAsTouched();
  //     });
  //   }
  //   else {
  //     this.submit()
  //   }
  // }






  dateValidation(item, i) {

    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let selectedDateControl = taskListArrays.controls[i].get('Date');
    let selectedDate = new Date(selectedDateControl.value);

    if (new Date(selectedDate).setHours(0, 0, 0, 0) < new Date(this.currentdate).setHours(0, 0, 0, 0)) {
      let data = {};
      data['message'] = 'You can not select previous date';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      taskListArrays.controls[i].get('Date').setValue('');
    }



    if (taskListArrays.controls[i].value['Date'].getDay() == 0) {
      let data = {};
      data['message'] = 'The Selected Day Is Sunday. Do You Still Want To Proceed?';
      data['title'] = 'Alert';
      data['icon'] = 'fa fa-question';
      this.dialogRef =
        this.modalPopupService.openPopup<ConformationModelComponent>(
          ConformationModelComponent,
          data
        );
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          taskListArrays.controls[i].get('Date').setValue(taskListArrays.controls[i].value['Date']);
        } else {
          taskListArrays.controls[i].get('Date').setValue('');
        }
      });
    }


    let isHoliday = this.holidayDates.some(holiday => {
      let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      let currentDate = selectedDate.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });

    if (isHoliday) {
      // Find all holidays that overlap with the selected date
      let overlappingHolidays = this.holidayDates.filter(holiday => {
        let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
        let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
        let currentDate = selectedDate.setHours(0, 0, 0, 0);
        return currentDate >= FromDate && currentDate <= ToDate;
      });

      // Join holiday names
      let holidayNames = overlappingHolidays.map(holiday => holiday.HolidayName).join(', ');

      let data = {
        message: `The Selected Day Is ${holidayNames}. Do You Still Want To Proceed?`,
        title: 'Alert',
        icon: 'fa fa-question'
      };
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result !== 'yes') {
          selectedDateControl.setValue('');
          // selectedDateControl.markAsUntouched();
        }
      });
    } else {
      selectedDateControl.setValue(selectedDateControl.value);
    }





    let previousRowDate = taskListArrays.controls[i - 1].value['Date'];
    if (i != 0 && (previousRowDate == '')) {
      let data = {}
      data['message'] = 'First Select Previous Row Date '
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('Date').setValue('');
    }


  }

  dateValidation2(item, i) {

    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let selectedDateControl = taskListArrays.controls[i].get('ToDate');
    let DateControl = taskListArrays.controls[i].get('Date');
    let selectedDate = new Date(selectedDateControl.value);
    let fromdate = new Date(DateControl.value);

    if (new Date(selectedDate).setHours(0, 0, 0, 0) < new Date(this.currentdate).setHours(0, 0, 0, 0)) {
      let data = {};
      data['message'] = 'You can not select previous date';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      taskListArrays.controls[i].get('ToDate').setValue('');
    }


    if (new Date(selectedDate).setHours(0, 0, 0, 0) < new Date(fromdate).setHours(0, 0, 0, 0)) {
      let data = {};
      data['message'] = 'You can not set To Date less than From Date';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      taskListArrays.controls[i].get('ToDate').setValue('');
    }

    if (taskListArrays.controls[i].value['ToDate'].getDay() == 0) {
      let data = {};
      data['message'] = 'The Selected Day Is Sunday. Do You Still Want To Proceed?';
      data['title'] = 'Alert';
      data['icon'] = 'fa fa-question';
      this.dialogRef =
        this.modalPopupService.openPopup<ConformationModelComponent>(
          ConformationModelComponent,
          data
        );
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          taskListArrays.controls[i].get('ToDate').setValue(taskListArrays.controls[i].value['ToDate']);
        } else {
          taskListArrays.controls[i].get('ToDate').setValue('');
        }
      });
    }


    let isHoliday = this.holidayDates.some(holiday => {
      let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      let currentDate = selectedDate.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });

    if (isHoliday) {
      // Find all holidays that overlap with the selected date
      let overlappingHolidays = this.holidayDates.filter(holiday => {
        let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
        let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
        let currentDate = selectedDate.setHours(0, 0, 0, 0);
        return currentDate >= FromDate && currentDate <= ToDate;
      });

      // Join holiday names
      let holidayNames = overlappingHolidays.map(holiday => holiday.HolidayName).join(', ');

      let data = {
        message: `The Selected Day Is ${holidayNames}. Do You Still Want To Proceed?`,
        title: 'Alert',
        icon: 'fa fa-question'
      };
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result !== 'yes') {
          selectedDateControl.setValue('');
          // selectedDateControl.markAsUntouched();
        }
      });
    } else {
      selectedDateControl.setValue(selectedDateControl.value);
    }





    let previousRowDate = taskListArrays.controls[i - 1].value['ToDate'];
    if (i != 0 && (previousRowDate == '')) {
      let data = {}
      data['message'] = 'First Select Previous Row Date '
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('ToDate').setValue('');
    }


  }


  getHoliday() {
    const payload = {};
    payload['SnNo'] = '';
    this.umsService.getExamHoliday(payload).subscribe(res => {
      if (res.status) {
        this.holidayDates = res.data.map(item => ({
          FromDate: new Date(item.FromDate),
          HolidayName: item.HolidayName
        }));
        this.cdr.detectChanges();
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  dateClass = (d: Date | null): string => {
    const date = d || new Date();
    const holiday = this.holidayDates.find(holiday => {
      const FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      const ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      const currentDate = date.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });
    if (holiday) {
      this.selectedHoliday = holiday;
      return 'holiday-date';
    } else {
      return '';
    }
  }


  getCenterAllocation(ShId) {
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = ShId;
    payload['EcInCode'] = 20;
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.examRecords = res.data;
          let allStatusU = true;
          this.examRecords.forEach(element => {
            if (element.EcInCode === 20 && element.EcStatus !== "U") {
              allStatusU = false;
            }
            if (allStatusU) {
              this.BtnDisable = true;
            } else {
              this.BtnDisable = false;
            }
          });
        }
        else {

        }
      },
      (ERROR: HttpErrorResponse) => {

        this.spinner.hide();
      }
    );

  }

  getCutoffDateForStudent() {
    const payload: any = {};
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getCuttoffDate(payload).subscribe(
      (res) => {
        if (res && res.status) {
          this.cutoffDetails = res.data?.[0];
        }
      },
      (ERROR: HttpErrorResponse) => {
        // ignore cutoff errors for timetable
      }
    );
  }

  loadAdmissionAndTimetable() {
    if (!this.StudentPersonalId) {
      return;
    }
    const payload: any = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe(
      (res) => {
        if (res && res.status && res.data && res.data.length > 0) {
          const adm = res.data[0];
          // Pre-fill form with admission details
          this.ExamTimeTable.patchValue({
            SessionId: adm.SessionId,
            CoCode: adm.StuCoId,
            EmId: adm.StuEmId,
            CgCode: adm.StuCgId,
            strId: adm.StuBrId
          });

          // Show table and load timetable data
          this.getTimetableData();
        }
      },
      (ERROR: HttpErrorResponse) => {
        // ignore admission errors for now
      }
    );
  }

  downloadAsPDF() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const filename = `PracticalTimeTable_${formattedDate}.pdf`;

    const options = {
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    const element = this.contentToConvert.nativeElement;
    const buttons = element.querySelectorAll('button');
    buttons.forEach(button => {
      button.style.display = 'none';
    });

    (html2pdf as any)()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        buttons.forEach(button => {
          button.style.display = '';
        });
      });
  }





  // update() {
  //   if (this.ExamTimeTable.invalid) {

  //     this.arr.controls.forEach(element => {
  //       element.get('Date')?.markAsTouched();
  //       element.get('PtTimeFrom').markAsTouched();
  //       element.get('PtTimeTo').markAsTouched();
  //     });
  //   }
  //   else {

  //     this.spinner.show();
  //     this.submitpayload = this.ExamTimeTable.value;
  //     let arr = [];
  //     arr = this.submitpayload.ExamArray
  //     let iserror = false;
  //     const payloadArray = [];  // Collect all payloads in an array
  //     arr.forEach((element, index) => {
  //       let fromdate = element.Date;
  //       let toDate = element.ToDate;
  //       element.Date = this.datepipe.transform(fromdate, 'yyyy-MM-dd');
  //       this.Time = element.Date + 'T' + element.PtTimeFrom + ':00.000Z'
  //       this.Totime = element.Date + 'T' + element.PtTimeTo + ':00.000Z'
  //       element.PtTimeFrom = this.Time;
  //       element.PtTimeTo = this.Totime;
  //       // if (element.AssigCnt == 0 || element.AssigCnt === 0) {
  //       //   this.AissgneCount = 1
  //       // } else {
  //       //   this.AissgneCount = element.AssigCnt
  //       // }
  //       const payload = {
  //         PtId: element.PtId,
  //         PtSnNo: this.submitpayload.SessionId ? this.submitpayload.SessionId : this.SessionNo,
  //         PtCoCode: this.submitpayload.CoCode,
  //         PtCgCode: this.submitpayload.CgCode,
  //         PtEmId: this.submitpayload.EmId,
  //         PtCent: this.submitpayload.CgCode,
  //         PtSubCode: element.EsCode,
  //         PtEsId: element.EsId,
  //         PtDate: element.Date,
  //         PtTimeFrom: element.PtTimeFrom,
  //         PtTimeTo: element.PtTimeTo,
  //         PtEsPSubId: element.PtEsPSubId,
  //       };

  //       payloadArray.push(payload);  // Add each payload to the array
  //     });

  //     this.umsService.updatePracticalTimeTable(payloadArray).subscribe(res => {
  //       this.spinner.hide();
  //       if (res.status == false) {
  //         this.spinner.hide();
  //         let data = {}
  //         data['message'] = this.errMsg
  //         data['title'] = 'Alert'
  //         data['icon'] = 'fas fa-close'
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       }
  //       // if (index === array.length - 1) resolve();
  //       else {
  //         this.spinner.hide();
  //         let data = {}
  //         data['message'] = "Updates Successfully"
  //         data['title'] = 'Information'
  //         data['icon'] = 'fas fa-check'
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //         this.getTable2(this.ExamTimeTable.value.Exam);
  //         this.getTimetableData()
  //       }
  //     }, (ERROR: HttpErrorResponse) => {
  //       this.spinner.hide();
  //       iserror = true;
  //       this.errMsg = ERROR.error.message
  //       // if (index === array.length - 1) resolve();
  //     });
  //     this.spinner.hide();


  //   }
  // }


  getBatchCount(index: number) {
    const examArray = this.ExamTimeTable.get('ExamArray') as FormArray;
    const row = examArray.at(index);

    const PStudCnt = +row.get('PStudCnt')?.value;
    const BatchSize = +row.get('BatchSize')?.value;

    if (PStudCnt > 0 && BatchSize > 0) {
      const batchCount = Math.round((PStudCnt / BatchSize) / 3);
      if (batchCount == 0 || batchCount === 0) {
        row.get('AssigCnt')?.setValue(1);
      } else {
        row.get('AssigCnt')?.setValue(batchCount);
      }
      // row.get('AssigCnt')?.setValue(batchCount);
    } else {
      row.get('AssigCnt')?.setValue('');
    }
  }


    checkvalidation(e) {
    return e.controls['PtTimeTo'].touched && e.controls['PtTimeTo'].errors?.toTimeBeforeFromTime;
  }
  checkvalidationtime(e) {
    return e.controls['PtTime'].touched && e.controls['PtTime'].errors?.toTimeBeforeFromTime;
  }
  checkvalidation1(e) {
    return e.controls['PtTimeTo'].touched && e.controls['PtTimeTo'].errors?.SameTime;
  }
  checkvalidationtime1(e) {
    return e.controls['PtTime'].touched && e.controls['PtTime'].errors?.SameTime;
  }

    condition() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      if (element.PtTimeFrom > element.PtTimeTo) {
        this.ExamTimeTable.get('PtTimeTo').setErrors({
          'SameTimeError': true
        })
      }
      else if (element.PtTimeFrom == element.PtTimeTo) {
       this.ExamTimeTable.get('PtTimeTo').setErrors({
          'SameTimeError': true
        })
      }
      else {
        this.ExamTimeTable.controls['PtTimeTo'].setErrors(null)
      }
      if (element.PtTimeTo == '23:59') {
        console.error('invalid data');
        this.ExamTimeTable.get('PtTimeTo').setErrors({
          'InValidTimeError': true
        })
      }
    });
  }
 
  condition2() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      this.ExamTimeTable.controls['PtTimeTo'].setErrors(null)
      if (element.Date < this.currentdate) {
        this.ExamTimeTable.get('Date').setErrors({
          'InValidDate': true
        })
      }
    });
 
 
  }
 
  condition1() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      if (element.PtTimeFrom == '23:59') {
        this.ExamTimeTable.get('PtTimeFrom').setErrors({
          'InValidTimeError': true
        })
      }
    });
  }

    checkToTime(e): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
      let payload = this.ExamTimeTable.value
      if (payload.ExamArray[e]) {
        const PtTimeFrom = payload.ExamArray[e]['PtTimeFrom'];
        const PtTimeTo = control.value;
        if (PtTimeFrom > PtTimeTo) {
          return { 'toTimeBeforeFromTime': true };
        } else if (PtTimeFrom < PtTimeTo) {
          return { 'fromTimeBeforetoTime': true };
        }
        else if (PtTimeFrom == PtTimeTo) {
          return { 'SameTime': true }
        }
        return null;
      };
    }
 
  }

    timeValidation2(e, i) {
    let fromTime = e.value.PtTimeFrom;
    let toTime = e.value.PtTimeTo;
    if (fromTime == '' || e.value.Date == '') {
      let data = {}
      data['message'] = 'First Select Date And From Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('PtTimeTo').setValue('');
    }
    else if (fromTime = '') {
      let data = {}
      data['message'] = 'First Select From Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('PtTimeTo').setValue('');
    }
    else if (e.value.PtTimeFrom >= e.value.PtTimeTo) {
      let data = {}
      data['message'] = 'To Date Is Not Less Than From Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('PtTimeTo').setValue('');
    }
  }
    checkValidation(item, index) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    // let previousRowDate= taskListArrays.controls[index - 1].value['Date'];
    // let previousRowFromTime =taskListArrays.controls[index - 1].value['PtTimeFrom'];
    // let previousRowToTime=taskListArrays.controls[index - 1].value['PtTimeTo'];
    // // else if (i !== 0 && item.value.Date == element.Date && previousTime == currentRowTime && element.Date != '') {  
    // let currentRowDate = item.value.Date;
    // let currentRowFromTime =item.value.PtTimeFrom;
    // let currentRowToTime = item.value.PtTimeTo;
    if (index != 0) {
      if (item.value.Date == '') {
        let data = {}
        data['message'] = 'First Selected date'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(index).get('PtTimeFrom').setValue('');
      }
      for (let i = index; i >= 0; i--) {
        const currentRow = taskListArrays.controls[i];
        //current
        let currentRowDate = currentRow.value.Date;
        let currentRowFromTime = currentRow.value.PtTimeFrom;
        let currentRowToTime = currentRow.value.PtTimeTo
 
        //previ
        let previousRowDate = taskListArrays.controls[i - 1].value['Date'];
        let previousRowFromTime = taskListArrays.controls[i - 1].value['PtTimeFrom'];
        let previousRowToTime = taskListArrays.controls[i - 1].value['PtTimeTo'];
        let cDate = this.datepipe.transform(currentRowDate, 'yyyy-MM-dd');
        let pDate = this.datepipe.transform(previousRowDate, 'yyyy-MM-dd');
        // && currentRowFromTime == previousRowFromTime
        if (currentRowFromTime == previousRowFromTime) {
          if (cDate == pDate) {
            let data = {}
            data['message'] = 'Date And Time Selected'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
            this.arr.at(index).get('PtTimeFrom').setValue('');
 
          }
          // else{
          //   let data = {}
          //   data['message'] = 'Date And Time Selected'
          //   data['title'] = 'Information'
          //   data['icon'] = 'fas fa-close'
          //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
          //   this.arr.at(index).get('PtTimeFrom').setValue('');
          // }
 
        }
        else if (cDate == pDate && currentRowFromTime <= previousRowToTime) {
          let data = {}
          data['message'] = 'Time Invalid'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
          this.arr.at(index).get('PtTimeFrom').setValue('');
 
        }
      }
    }
    else {
      const currentRow = taskListArrays.controls[index];
      //current
      let currentRowDate = item.value.Date;
      let currentRowFromTime = item.value.PtTimeFrom;
      let currentRowToTime = item.value.PtTimeTo
 
      if (currentRowDate == '') {
        let data = {}
        data['message'] = 'First Selected date'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(index).get('PtTimeFrom').setValue('');
      }
    }
 
 
    const filteredElements = this.arr.filter(element => {
      let fromTime = element.PtTimeFrom;
      let toTime = element.PtTimeTo
    });
  }

}
